import {
    ADD_LANE,
    DELETE_LANE,
    EDIT_LANE,
    LOAD_LANE,
  } from '../../actions/boardLane';

  export default function boardLane(state = {}, action) {
      switch (action.type) {
          case ADD_LANE:
            return Object.assign({}, state, action.payload);
          case DELETE_LANE:
            return Object.assign({}, state, action.payload);
          case EDIT_LANE:
            return Object.assign({}, state, action.payload);
          case LOAD_LANE:
            return Object.assign({}, state, action.payload);
          default:
            return state;
      }
  }


// WEBPACK FOOTER //
// ./src/reducers/boardLane/index.js